import { Flex } from "@similarweb/ui-components/foundations";

import { Spinner } from "pro-features/components/Loaders/src/Spinner";

export const Loader = () => {
    return (
        <Flex
            height="100%"
            width="100%"
            justifyContent="center"
            alignItems="center"
        >
            <Spinner />
        </Flex>
    );
};
